import SiafLiteApiRepository from "../../external/siafLiteApi";

class ClassificacoesServicoNacionalService {
  constructor() {
    this.urlBase = "/estoque/classificacoes-servicos-nacionais";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filtros) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filtros);
  }
}

export default ClassificacoesServicoNacionalService;
